import Typography from '@mui/material/Typography';
import { useParams } from "react-router-dom";

import OpenApiFormGenerator from "../core/FormGenerator";
import Session from '../shared/Session';
import { titleCase } from '../shared/Utilities';

export default function SchemaForm() {
    const { parent_schema_name, schema_name, id } = useParams();

    let method = "post"
    let path = "/" + schema_name + "/";

    if (id !== undefined) {
        method = "put"
        path = "/" + schema_name + "/{" + schema_name?.slice(0, -1) + "_id}";
    }

    if (parent_schema_name !== undefined) {
        path = "/" + parent_schema_name + path;
    }

    const urlParams = new URLSearchParams(window.location.search);
    let redirect_to = urlParams.get('redirect_to');

    console.log("SchemaForm path: " + path);

    return (
        <>
            <Typography variant="h4" align="left" gutterBottom component="h2">
                {titleCase(schema_name?.slice(0, -1) || "")}
            </Typography>
            <OpenApiFormGenerator
                id={id}
                method={method}
                path={path}
                setResult={() => { 
                    if (redirect_to !== null) {
                        Session.navigate(redirect_to);
                    } else {
                        Session.navigate("/data?view=" + schema_name);
                    }
                }}
            />
        </>
    )
};
